import { type IModelData } from '../queries/use-GLTF-urls';
import { useQueryClientValue } from './use-query-client-value';
import { MODEL_URLS } from '../constants/query-keys';

export const useGetCarModel = (id: string) => {
    const urls = useQueryClientValue<IModelData>(MODEL_URLS);
    return urls?.cars?.find((item) => item.model_id === id);
};
